import styled from '@emotion/styled'
import Modal, {
  StyledModalContainer,
  ModalProps
} from 'shared/library/molecules/Modal'
import ModalContentRedeemVoucher, {
  ModalContentRedeemVoucherInterface
} from 'library/molecules/ModalContentRedeemVoucher/ModalContentRedeemVoucher'

interface ModalRedeemVoucherInterface
  extends ModalContentRedeemVoucherInterface {
  isOpen: ModalProps['isOpen']
}

/**
 * Please refer to https://www.notion.so/eola/Modals-new-widget-d5a5b2c100c840878761cd28bb3279a2
 * for an explanation on our approach to Modals
 */
const ModalRedeemVoucher = ({
  isOpen,
  ...props
}: ModalRedeemVoucherInterface) => {
  return (
    <StyledModal isOpen={isOpen}>
      <ModalContentRedeemVoucher {...props} />
    </StyledModal>
  )
}

export default ModalRedeemVoucher

const StyledModal = styled(Modal)(({ theme }) => ({
  [`${StyledModalContainer}`]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: theme.mixins.pxSpread([0, theme.space[4]]),
    padding: `${theme.space[7]}px ${theme.space[5]}px`
  }
}))
